export enum ThemeType{
    DarkTheme = 'dark-theme',
    DefaultTheme = 'default-theme',
    ThemeOne = 'theme-alternate-one',
}
